import { RouteConfig } from 'vue-router';
import SwFtrHelloSonicwall from './sw-ftr-hello-sonicwall.vue';

const route:RouteConfig = {
  path: 'hello-sonicwall',
  component: SwFtrHelloSonicwall,
};

export function getDefaultParams() {
  return {};
}

export default route;
